import React, { useMemo } from 'react';
import { arrayOf, func, bool } from 'prop-types';
import classnames from 'classnames';
import projectItemType from '../../../utils/types/projectItem';
import ProjectTitle from '../../common/ProjectGrid/ProjectTitle';
import GridImage from '../../common/ProjectGrid/ProjectImage';
import { MAX_PROJECTS_IN_GRID } from './constants';
import './style.scss';

const PortfolioPresenceProjectGrid = ({ projectList, selectProject, isWideTheme = false }) => {
    const displayedProjects = useMemo(() => projectList.slice(0, MAX_PROJECTS_IN_GRID), [projectList]);

    return (
        <ul className={classnames('project-grid', `grid-${displayedProjects.length}`, 'm-b-24', isWideTheme ? 'wide-grid' : 'slim-grid')}>
            { displayedProjects.map((project, index) => (
                <li key={project.id} className={classnames('project-photo', `photo-${index}`)} onClick={() => selectProject(project.id)}>
                    <GridImage imagePath={project.item}/>
                    <ProjectTitle title={project.title}/>
                </li>
            )) }
        </ul>
    );
};

PortfolioPresenceProjectGrid.propTypes = {
    projectList: arrayOf(projectItemType).isRequired,
    selectProject: func.isRequired,
    isWideTheme: bool
};

export default PortfolioPresenceProjectGrid;
